module.exports = __webpack_public_path__ + "static/about-insta-10-262b3478361806c41c98d6323b7a8801.jpg";